import { QueryClientProvider as TanstackQueryClientProvider } from '@tanstack/react-query';
import type { ReactNode } from 'react';

import { queryClient } from '@perpay-web/services/queryClient';

type QueryClientProviderProps = {
    children: ReactNode;
};

export const QueryClientProvider = ({ children }: QueryClientProviderProps) => (
    <TanstackQueryClientProvider client={queryClient}>
        {children}
    </TanstackQueryClientProvider>
);
